export default "__VITE_ASSET__tbgL_dQp__"